import cookies from 'vue-cookies'
// import store from 'store'
import * as types from '../types'

export default ({
  state: {
    signinStatus: false,
    token: null,
    userData: null,
    expireTime: null,
  },
  getters: {
    signinStatus: state => state.signinStatus,
    token: state => state.token,
    userData: state => state.userData,
    expireTime: state => state.expireTime,
    userName: state => { return (state.userData ? state.userData.name : '') },
    userId: state => { return (state.userData ? state.userData.id : '') }
  },
  mutations: {
    [types.SIGNIN_STATUS](state, res) {
      state.signinStatus = res
    },
    [types.TOKEN](state, res) {
      state.token = res
    },    
    [types.USER_DATA](state, res) {
      state.userData = res
    },
    [types.EXPIRE_TIME](state, res) {
      state.expireTime = res
    },
  },
  actions: {
    setSignInStatus({ commit }, params) {
      // store.set('signinStatus', params)
      cookies.set('signinStatus', params)
      commit(types.SIGNIN_STATUS, params);
    },
    setToken({ commit }, res) {
      // store.set('token', res)
      cookies.set('token', res)
      commit(types.TOKEN, res)
    },    
    setUserData({ commit }, res) {
      // store.set('userData', res)
      cookies.set('userData', res)
      commit(types.USER_DATA, res)
    },
    setExpireTime({ commit }, res) {
      cookies.set('expireTime', res)
      commit(types.EXPIRE_TIME, res)
    },  
    extendExpire(commit, res) {
      cookies.config(res, '')
    },  
    signOut({ commit }) {
      // store.remove('signinStatus')
      // store.remove('token')
      // store.remove('userData')
      cookies.remove('signinStatus')
      cookies.remove('token')
      cookies.remove('expireTime')
      cookies.remove('userData')
      commit(types.SIGNIN_STATUS, false)
      commit(types.TOKEN, null)
      commit(types.EXPIRE_TIME, null)
      commit(types.USER_DATA, null)
    },
  }
})